import { DATA_LAYER_REGEX } from "@/constants/regex"
import { getPureText } from "@/utils/helper"

export const makingTextDatalayerReady = text => {
  return getPureText(text)
    ?.toLowerCase()
    ?.replace(DATA_LAYER_REGEX, "&")
    ?.trim()
}
